@if (showLoadingComponent()) {
  <app-loading-page
    [title]="splashTitle()"
    [logoSrc]="splashLogo()"
    [variant]="splashVariant()"
    [isLoading]="isLoading()"
  ></app-loading-page>
}
<router-outlet></router-outlet>
